// extracted by mini-css-extract-plugin
module.exports = {"notifications__container":"style_notifications__container__1nnXs","notifications__loader":"style_notifications__loader__2YluE"};